import React, { Component } from 'react';
import { Link } from 'react-router';
import { database } from 'firebase';
import Loader from '../Books/Loader';

class Keywords extends Component {
  constructor () {
    super ();
    this.booksRef = database().ref('/books');
    this.state = {
      keywords: null
    }
  }
  componentWillMount () {
    this.booksRef.on('value', (snapshot) => {
      let keywords = [],
          sortedKeywords;
      snapshot.forEach(snap => {
        let book = snap.val();
        if (!book.Keywords) {
          book.Keywords = 0;
        }
        if (book.Keywords !== 0) {
          book.Keywords.forEach(k => {
            if ( keywords.indexOf(k) < 0 ) {
              keywords.push(k);
            }
          });
        }
      })
      sortedKeywords = keywords.sort((a,b) => {
        if (a < b) return -1;
        if (b < a) return 1;
        return 0;
      });
      this.setState({
        keywords: sortedKeywords
      });
      console.log('finished loading keyword data');
    });
  }

  componentWillUnmount () {
    this.booksRef.off();
  }

  render () {
    // let keywordComponents;
    // if (this.state.keywords) {
    //   keywordComponents = this.state.keywords.map((keyword, index) => {
    //     let path = "/keywords/" + keyword + "";
    //     return <Link to={path} key={index} className="btn btn-default">{keyword}</Link>;
    //   });
    // }

    let keywordComponents = this.state.keywords ? this.state.keywords.map((keyword, index) => {
      let path = "/keywords/" + keyword + "";
      return <Link to={path} key={index} className="btn btn-default">{keyword}</Link>;
    }) : (
      <Loader />
    )

    return (
      <div className="keywords-container">
        <h2>Keywords</h2>
        {keywordComponents}
      </div>
    );

  }
}

export default Keywords;



/** WEBPACK FOOTER **
 ** ./src/components/Pages/Keywords.js
 **/